
import lesson from "./lesson";

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    lesson,
  },
};
